import TaskStatusesCollection from './task-statuses-collection'
import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import SessionCustomField from "../custom-field/session-custom-field";
import TaskTypeSettings from "./task-type-settings/task-type-settings"
import TemplateData
    from "../../../app/settings/tasks-projects/task-types/view/components/template/model/template-data";

const debug = false
// const debug = "TaskType"

export default class TaskType extends ModelEntity {

    public companyId        : string
    public name             : string
    public icon             : string
    public statuses         : TaskStatusesCollection | null
    public isDeleted        : boolean
    // sortPosition    : number

    public templateTitle    : string
    public templateMessage  : string

    public customFields     : ID[]

    public settings         : TaskTypeSettings
    public type             : string

    public templateData     : TemplateData

    constructor(data:any) {
        super(data?.id, EntityType.DYNAMIC_MODEL)
        // this.id                 = data['id']
        this.companyId          = data['companyId']
        this.name               = data['name']
        this.icon               = _.get(data, 'icon', 'task')
        this.statuses           = data['statuses'] ? TaskStatusesCollection.initFromJson(data['statuses']) : null
        this.isDeleted          = _.get(data, 'isDeleted', false)
        this.sortPosition       = data['sortPosition']

        this.templateTitle      = data['templateTitle']
        this.templateMessage    = data['templateMessage']
        this.customFields       = _.get(data, 'customFields', [])
        this.settings           = new TaskTypeSettings(data['settings'])
        this.type               = this.settings.isGeneric ? "Default" : ""

        this.templateData       = data['templateData'] ? new TemplateData(data['templateData']) : null

        debug && console.log(debug, 'constructor', this, data)
    }

    public goToSettings() {
        gd.navigation.goTo('settings/task-types/'+this.id)
    }

    // hack for Edit task type form
    get isDefault() {
        return this.settings.isGeneric
    }

    set isDefault(value: boolean) {
        this.settings.isGeneric = value
    }

    get missingCustomFields():ID[]|null {
        const missingCustomFieldIds : ID[] = []

        _.map(this.customFields, (customFieldId:ID)=>{
            if (!gd.session.customFields.get(customFieldId)) {
                missingCustomFieldIds.push(customFieldId)
            }
        })

        if (_.isEmpty(missingCustomFieldIds)) return null

        return missingCustomFieldIds
    }

    public hasSystemField(fieldId:string):boolean {
        return !this.settings.hiddenFields?.includes(fieldId)
    }

    public get hasFieldAssignee():boolean {
        return this.hasSystemField(gd.fields.task.assignedToUserId.fieldId)
    }

    public get hasFieldAR():boolean {
        return this.hasSystemField(gd.fields.task.actionRequiredUserId.fieldId)
    }

    // required custom fields are kept in the same setting as the required system ones
    public get hasRequiredCustomFields():boolean {
        return _.some(this.customFields, (customFieldId:ID)=> this.settings.requiredFields.includes(customFieldId))
    }

    clone() {
        return new TaskType(this.toJSON());
    }

    validate(): ErrorProto[] | null {
        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.taskType.name))
        if (!this.icon) errors.push(new ErrorFieldRequired(gd.fields.taskType.icon))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    get customFieldObjects():SessionCustomField[] {

        const result : SessionCustomField[] = []

        _.map(this.customFields, (customFieldId:ID)=>{
            const customField = gd.session.customFields.get(customFieldId)
            if (customField) {
                result.push(customField)
            }
        })

        // this.customFields.map((id:ID) => gd.session.customFields.get(id)) : [];
        return result
    }


    toJSON() {

        const result: any = {
            id              : this.id,
            companyId       : this.companyId,
            name            : this.name,
            icon            : this.icon,
            statuses        : this.statuses ? this.statuses.toJSON() : null,
            isDeleted       : this.isDeleted,
            sortPosition    : this.sortPosition,

            templateTitle   : this.templateTitle,
            templateMessage : this.templateMessage,

            customFields    : this.customFields,

            settings        : this.settings.toJSON(),
        }

        if (this.templateData) {
            result.templateData = this.templateData.toJSON()
        }

        return result

    }
}
